export const paymenttableColumns = [
  {
    id: "createdAt",
    label: "Transaction Date",
    minWidth: 70,
    align: "left",
  },
  {
    id: "shortCode",
    label: "paymentId",
    minWidth: 70,
    align: "left",
  },
  {
    id: "fullName",
    label: "Name",
    minWidth: 70,
    align: "left",
  },
  {
    id: "email",
    label: "Email",
    minWidth: 70,
    align: "left",
  },
  // {
  //   id: "phoneNumber",
  //   label: "Phone Number",
  //   minWidth: 70,
  //   align: "center",
  // },
  // {
  //   id: "address",
  //   label: "Address",
  //   minWidth: 70,
  //   align: "left",
  // },
  {
    id: "totalPrice",
    label: "Amount",
    minWidth: 70,
    align: "center",
  },
  // {
  //   id: "country",
  //   label: "Country",
  //   minWidth: 70,
  //   align: "center",
  // },
  {
    id: "status",
    label: "Status",
    minWidth: 70,
    align: "center",
  },
];
